import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { useUser } from '../providers/UserProvider';
import { isVisit, readerEvent, readerView, type ReaderView } from '../utils/readerTelemetry';

export function ReaderVisitTracker() {
  const location = useLocation();
  const navigation = useNavigationType();
  const { isLoggedIn } = useUser();
  const last = useRef<{ locationKey: string; view: ReaderView | null } | null>(null);
  useEffect(() => {
    if (last.current?.locationKey === location.key) return;
    const view = readerView(location.pathname, location.search, isLoggedIn);
    if (isVisit(last.current?.view ?? null, view, navigation) && view) {
      const { key: _key, ...properties } = view;
      readerEvent('visit', properties);
    }
    last.current = { locationKey: location.key, view };
  }, [location.key, location.pathname, location.search, navigation, isLoggedIn]);
  return null;
}
